// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlertsBell_wrap__p6f0F {
  position: relative;
  display: inline-flex;
}

.AlertsBell_bell__UWKyV {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #1b3a34;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.AlertsBell_bell__UWKyV svg {
  color: #1b3a34;
}
.AlertsBell_bell__UWKyV:hover {
  background: #f9f8f7;
  color: #17322d;
}

.AlertsBell_bellIcon__Zx7M- {
  position: relative;
  display: inline-flex;
}

.AlertsBell_badge__Yg-mT {
  position: absolute;
  top: -5px;
  right: -6px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #ff5a00;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

.AlertsBell_bellLabel__azLrF {
  white-space: nowrap;
}

.AlertsBell_panel__rMj2h {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 50;
  width: 360px;
  max-width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;
  max-height: min(520px, 100vh - 120px);
  background: #ffffff;
  border: 1px solid #f0efee;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.14);
  font-family: "Inter Tight";
  overflow: hidden;
}

.AlertsBell_panelHead__BDe-R,
.AlertsBell_panelFoot__gspEz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
}

.AlertsBell_panelHead__BDe-R {
  border-bottom: 1px solid #f0efee;
}

.AlertsBell_panelFoot__gspEz {
  border-top: 1px solid #f0efee;
}

.AlertsBell_panelTitle__weAbk {
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
}

.AlertsBell_linkBtn__5sHgq {
  border: none;
  background: none;
  padding: 0;
  color: #1b3a34;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}
.AlertsBell_linkBtn__5sHgq:hover {
  color: #17322d;
  text-decoration: underline;
}

.AlertsBell_list__WoNdU {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
}

.AlertsBell_empty__K4Ev5 {
  padding: 16px;
  color: #737373;
  font-size: 13px;
}

.AlertsBell_item__CSCIw {
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-bottom: 1px solid #f0efee;
  background: transparent;
  text-align: left;
  font: inherit;
  cursor: pointer;
}
.AlertsBell_item__CSCIw:hover {
  background: #f9f8f7;
}

.AlertsBell_dot__GuvMh {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: transparent;
}

.AlertsBell_unread__WoNjT .AlertsBell_dot__GuvMh {
  background: #ff5a00;
}

.AlertsBell_itemBody__8RYJX {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.AlertsBell_itemTitle__Z6YLz {
  font-size: 13px;
  font-weight: 500;
  color: #0a0a0a;
  overflow-wrap: anywhere;
}

.AlertsBell_unread__WoNjT .AlertsBell_itemTitle__Z6YLz {
  font-weight: 600;
}

.AlertsBell_itemText__oiAn3 {
  font-size: 12px;
  color: #737373;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.AlertsBell_itemTime__yXb\\+E {
  font-size: 11px;
  color: #a3a3a3;
}

.AlertsBell_toastText__3S0Em {
  font-size: 12px;
  margin-top: 2px;
}

@media (max-width: 1139.98px) {
  .AlertsBell_bellLabel__azLrF {
    display: none;
  }
  .AlertsBell_panel__rMj2h {
    position: fixed;
    top: 64px;
    right: 16px;
    left: 16px;
    width: auto;
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/admin-alerts/AlertsBell.module.scss","webpack://./src/layouts/PortalLayout/tokens.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QCwCmB;EDvCnB,cAAA;EACA,YAAA;EACA,kBCiCmB;EDhCnB,uBAAA;EACA,cCCmB;EDAnB,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAHF;AAKE;EACE,cCNiB;ADGrB;AAME;EACE,mBCOiB;EDNjB,cCViB;ADMrB;;AAQA;EACE,kBAAA;EACA,oBAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBCLmB;EDMnB,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,mBCpCmB;EDqCnB,yBAAA;EACA,kBCvBmB;EDwBnB,8CAAA;EACA,0BCLS;EDMT,gBAAA;AALF;;AAQA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QC9BmB;ED+BnB,kBAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,6BAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cC1EmB;ADqErB;;AAQA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cCvFmB;EDwFnB,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AALF;AAOE;EACE,cC9FiB;ED+FjB,0BAAA;AALJ;;AASA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;AANF;;AASA;EACE,aCxEmB;EDyEnB,cCvGmB;EDwGnB,eAAA;AANF;;AASA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AANF;AAQE;EACE,mBC9GiB;ADwGrB;;AAUA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,mBCnHmB;AD4GrB;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cCpJmB;EDqJnB,uBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,cC7JmB;ED8JnB,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,cCtKmB;AD+JrB;;AAUA;EACE,eAAA;EACA,eAAA;AAPF;;AAUA;EACE;IACE,aAAA;EAPF;EAUA;IACE,eAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EARF;AACF","sourcesContent":["@import \"../../layouts/PortalLayout/tokens\";\n\n// Topbar bell + its dropdown. The button matches the Topbar `.action` style.\n\n.wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.bell {\n  display: inline-flex;\n  align-items: center;\n  gap: $lux-space-1;\n  padding: 0 8px;\n  border: none;\n  border-radius: $lux-radius;\n  background: transparent;\n  color: $lux-primary;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n\n  svg {\n    color: $lux-primary;\n  }\n\n  &:hover {\n    background: $lux-surface-muted;\n    color: $lux-primary-600;\n  }\n}\n\n.bellIcon {\n  position: relative;\n  display: inline-flex;\n}\n\n.badge {\n  position: absolute;\n  top: -5px;\n  right: -6px;\n  min-width: 15px;\n  height: 15px;\n  padding: 0 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background: $lux-accent;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.bellLabel {\n  white-space: nowrap;\n}\n\n.panel {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  z-index: 50;\n  width: 360px;\n  max-width: calc(100vw - 32px);\n  display: flex;\n  flex-direction: column;\n  max-height: min(520px, calc(100vh - 120px));\n  background: $lux-surface;\n  border: 1px solid $lux-stroke;\n  border-radius: $lux-radius-lg;\n  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.14);\n  font-family: $lux-font;\n  overflow: hidden;\n}\n\n.panelHead,\n.panelFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $lux-space-2;\n  padding: $lux-space-3 $lux-space-4;\n}\n\n.panelHead {\n  border-bottom: 1px solid $lux-stroke;\n}\n\n.panelFoot {\n  border-top: 1px solid $lux-stroke;\n}\n\n.panelTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: $lux-text-primary;\n}\n\n.linkBtn {\n  border: none;\n  background: none;\n  padding: 0;\n  color: $lux-primary;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:hover {\n    color: $lux-primary-600;\n    text-decoration: underline;\n  }\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.empty {\n  padding: $lux-space-4;\n  color: $lux-text-secondary;\n  font-size: 13px;\n}\n\n.item {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  padding: 10px $lux-space-4;\n  border: none;\n  border-bottom: 1px solid $lux-stroke;\n  background: transparent;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n\n  &:hover {\n    background: $lux-surface-muted;\n  }\n}\n\n.dot {\n  flex-shrink: 0;\n  width: 8px;\n  height: 8px;\n  margin-top: 6px;\n  border-radius: 50%;\n  background: transparent;\n}\n\n.unread .dot {\n  background: $lux-accent;\n}\n\n.itemBody {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.itemTitle {\n  font-size: 13px;\n  font-weight: 500;\n  color: $lux-text-primary;\n  overflow-wrap: anywhere;\n}\n\n.unread .itemTitle {\n  font-weight: 600;\n}\n\n.itemText {\n  font-size: 12px;\n  color: $lux-text-secondary;\n  overflow-wrap: anywhere;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.itemTime {\n  font-size: 11px;\n  color: $lux-text-tertiary;\n}\n\n.toastText {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n@media (max-width: $lux-bp-collapse) {\n  .bellLabel {\n    display: none;\n  }\n\n  .panel {\n    position: fixed;\n    top: 64px;\n    right: 16px;\n    left: 16px;\n    width: auto;\n    max-width: none;\n  }\n}\n","// =============================================================================\n// Lumiere Ivory — Supplier Portal design tokens\n// -----------------------------------------------------------------------------\n// Single source of truth for the new theme, mapped 1:1 from the Figma variables\n// (Supplier V1 · node 84-45990). This is the foundation of the theme migration:\n// new/migrated components consume the `--lux-*` custom properties emitted by the\n// `lux-tokens` mixin (applied on the shell root in PortalLayout.module.scss), or\n// the `$lux-*` Sass variables directly inside the layout modules.\n//\n//   Figma variable            ->  token\n//   Primary/500 *             ->  $lux-primary\n//   Background/Surface/Default->  $lux-surface\n//   Stroke/Primary            ->  $lux-stroke\n//   Spacing/4 (8)             ->  $lux-space-2\n//   Radius/8                  ->  $lux-radius-lg\n// =============================================================================\n\n// ── Brand ────────────────────────────────────────────────────────────────────\n$lux-primary:        #1b3a34; // Primary/500 *\n$lux-primary-600:    #17322d; // Primary/600 (hover / pressed)\n$lux-primary-200:    #bdd3ce; // Primary/200 (tint)\n$lux-on-primary:     #ffffff;\n\n// ── Text ─────────────────────────────────────────────────────────────────────\n$lux-text-primary:   #0a0a0a; // Text/Primary\n$lux-text-secondary: #737373; // Text/Secondary\n$lux-text-tertiary:  #a3a3a3; // Text/Tertiery\n\n// ── Icon ─────────────────────────────────────────────────────────────────────\n$lux-icon-primary:   #0a0a0a; // Icon/Primary\n$lux-icon-secondary: #6f7173; // Icon/Secondary\n$lux-icon-tertiary:  #8a8c8f; // Icon/Tertiery\n\n// ── Surface ──────────────────────────────────────────────────────────────────\n$lux-surface:        #ffffff; // Background/Surface/Default\n$lux-surface-muted:  #f9f8f7; // Background/Surface/Neutral Lv1\n$lux-page-bg:        #f3f2f0; // page bg behind the floating panels\n\n// ── Stroke ───────────────────────────────────────────────────────────────────\n$lux-stroke:         #f0efee;                  // Stroke/Primary\n$lux-stroke-strong:  #dfdfdf;                  // Stroke/Tertiery\n$lux-panel-border:   rgba(115, 124, 127, 0.14); // floating panel hairline\n\n// ── Accent (danger / destructive) ────────────────────────────────────────────\n$lux-accent:         #ff5a00; // Orange/500 *\n$lux-accent-600:     #e85200; // Orange/600\n\n// ── Radius ───────────────────────────────────────────────────────────────────\n$lux-radius:         4px; // Radius/4 (controls, nav items)\n$lux-radius-lg:      8px; // Radius/8 (panels, cards)\n\n// ── Spacing ──────────────────────────────────────────────────────────────────\n$lux-space-1:        6px;  // Spacing/3\n$lux-space-2:        8px;  // Spacing/4\n$lux-space-3:        12px; // Spacing/5\n$lux-space-4:        16px;\n$lux-space-5:        20px;\n$lux-shell-gap:      8px;  // gap between the two floating panels\n\n// ── Elevation ────────────────────────────────────────────────────────────────\n$lux-shadow-xs:      0 1px 2px rgba(10, 13, 20, 0.03); // regular-shadow/x-small\n\n// ── Geometry ─────────────────────────────────────────────────────────────────\n$lux-sidebar-width:  270px;\n$lux-topbar-height:  64px;\n$lux-bp-collapse:    1139.98px; // below this the sidebar becomes a drawer\n\n// ── Typography ───────────────────────────────────────────────────────────────\n// Inter Tight only — no fallback of any kind (not even the generic sans-serif).\n$lux-font: 'Inter Tight';\n// type scale (size / weight / line-height) from the Figma text styles\n$lux-text-body:    14px; // Label/Small         500 / 20\n$lux-text-label:   12px; // Label/X-Small       500 / 16\n$lux-text-title-h5: 24px; // Title/H-5          600 / 32\n\n// -----------------------------------------------------------------------------\n// Emit the palette as CSS custom properties so migrated components can theme\n// against `var(--lux-*)` instead of hard-coding hexes. Applied once on the\n// shell root (.shell) — values cascade to every descendant.\n// -----------------------------------------------------------------------------\n@mixin lux-tokens {\n  --lux-primary: #{$lux-primary};\n  --lux-primary-600: #{$lux-primary-600};\n  --lux-primary-200: #{$lux-primary-200};\n  --lux-on-primary: #{$lux-on-primary};\n\n  --lux-text-primary: #{$lux-text-primary};\n  --lux-text-secondary: #{$lux-text-secondary};\n  --lux-text-tertiary: #{$lux-text-tertiary};\n\n  --lux-icon-primary: #{$lux-icon-primary};\n  --lux-icon-secondary: #{$lux-icon-secondary};\n  --lux-icon-tertiary: #{$lux-icon-tertiary};\n\n  --lux-surface: #{$lux-surface};\n  --lux-surface-muted: #{$lux-surface-muted};\n  --lux-page-bg: #{$lux-page-bg};\n\n  --lux-stroke: #{$lux-stroke};\n  --lux-stroke-strong: #{$lux-stroke-strong};\n  --lux-panel-border: #{$lux-panel-border};\n\n  --lux-accent: #{$lux-accent};\n  --lux-accent-600: #{$lux-accent-600};\n\n  --lux-radius: #{$lux-radius};\n  --lux-radius-lg: #{$lux-radius-lg};\n\n  --lux-space-1: #{$lux-space-1};\n  --lux-space-2: #{$lux-space-2};\n  --lux-space-3: #{$lux-space-3};\n  --lux-space-4: #{$lux-space-4};\n\n  --lux-shadow-xs: #{$lux-shadow-xs};\n  --lux-sidebar-width: #{$lux-sidebar-width};\n  --lux-topbar-height: #{$lux-topbar-height};\n\n  --lux-font: #{$lux-font};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `AlertsBell_wrap__p6f0F`,
	"bell": `AlertsBell_bell__UWKyV`,
	"bellIcon": `AlertsBell_bellIcon__Zx7M-`,
	"badge": `AlertsBell_badge__Yg-mT`,
	"bellLabel": `AlertsBell_bellLabel__azLrF`,
	"panel": `AlertsBell_panel__rMj2h`,
	"panelHead": `AlertsBell_panelHead__BDe-R`,
	"panelFoot": `AlertsBell_panelFoot__gspEz`,
	"panelTitle": `AlertsBell_panelTitle__weAbk`,
	"linkBtn": `AlertsBell_linkBtn__5sHgq`,
	"list": `AlertsBell_list__WoNdU`,
	"empty": `AlertsBell_empty__K4Ev5`,
	"item": `AlertsBell_item__CSCIw`,
	"dot": `AlertsBell_dot__GuvMh`,
	"unread": `AlertsBell_unread__WoNjT`,
	"itemBody": `AlertsBell_itemBody__8RYJX`,
	"itemTitle": `AlertsBell_itemTitle__Z6YLz`,
	"itemText": `AlertsBell_itemText__oiAn3`,
	"itemTime": `AlertsBell_itemTime__yXb+E`,
	"toastText": `AlertsBell_toastText__3S0Em`
};
export default ___CSS_LOADER_EXPORT___;
